function analyticsZephrOutcomeHistoryHandler(analyticsEventBusMessage) {
  try {
    const { eventType: conversion, options: { outcomeId, outcomeSlug } = {} } =
      analyticsEventBusMessage;

    if (__DEV__) {
      console.info(
        'Web.Zephr:analytics:analyticsZephrOutcomeHistoryHandler:',
        analyticsEventBusMessage,
      );
    }

    const shouldZephrOutcomeHistoryAppendBail =
      // Ignore load events since we only have 5mb of storage to work with
      conversion.endsWith('load') || !outcomeId || !outcomeSlug;
    if (shouldZephrOutcomeHistoryAppendBail) {
      if (__DEV__ || __PROD__) {
        if (!outcomeId) {
          console.error(
            'Web.Zephr:analyticsZephrOutcomeHistoryHandler: missing required parameter outcomeId. Please contact marketing to populate the analyticsOutcomeId variable in the Zephr Console for the outcome.',
            analyticsEventBusMessage,
          );
        }

        if (!outcomeSlug) {
          console.error(
            'Web.Zephr:analyticsZephrOutcomeHistoryHandler: missing required parameter outcomeSlug. analyticsOutcomeSlug is derived from the window.Zephr.outcomes object on the top page after Adobe Launch code executes Zephr.run(...) call and the deriveOutcomeSlugFromWindowZephr lookup has failed. This is likely due to an empty or duplicate analyticsOutcomeId being set in the Zephr Console. analyticsOutcomeId is a required field for each outcome and must be unique across all features/journeys, please contact marketing to have this field correctly populated. Tracking for this outcome inside of Zephr Analytics will not populate until this is done.',
            analyticsEventBusMessage,
          );
        }
      }

      return;
    }

    const outcomeHistoryEntry = {
      conversion,
      outcomeId,
      createdAt: new Date().toISOString(),
      epoch: Math.round(Date.now() / 1000),
      outcomeSlug,
    };

    const onZephrOutcomeHistoryAppendEvent = new CustomEvent(
      'onzephroutcomehistoryappend',
      {
        detail: {
          outcomeHistoryEntry,
        },
      },
    );

    return window.dispatchEvent(onZephrOutcomeHistoryAppendEvent);
  } catch (e) {
    console.error('Web.Zephr:Error: analyticsZephrOutcomeHistoryHandler', e);

    return e;
  }
}

export default analyticsZephrOutcomeHistoryHandler;
